/**
 * Plain-English display names for parent packet forms (presentation only).
 * Keys are site slugs; form IDs unchanged.
 */
export const PACKET_FRIENDLY_FORM_NAMES = {
  rockland: {
    form_01: 'Welcome & program overview',
    form_02: 'Parent file rights',
    form_03: 'Parents as partners',
    form_04: 'Immunization requirements',
    form_05: 'School calendar',
    form_07: 'Emergency contacts & procedures',
    form_08: 'Medical & health history',
    form_09: 'Allergy & dietary needs',
    form_10: 'Student identification',
    form_11: 'OTC medication consent',
    form_12: 'Creams & lotions consent',
    form_13: 'Photo & media release',
    form_14: 'Authorized pickup persons',
    form_15: 'Release of records',
    form_16: 'Allergy emergency plan',
    form_17: 'School meals application',
    form_18: 'Illness policy acknowledgment',
    form_19: 'Handbook acknowledgment',
    form_20: 'PHI authorization',
  },
  '14th-ave': {
    fa_01: 'Parent information letters',
    fa_02: 'School calendars',
    fa_15: 'Educational records & privacy',
    fa_03: 'Emergency preparedness & bus',
    fa_04: 'Emergency procedure',
    fa_05: 'Medical examination',
    fa_06: 'Medication consent',
    form_10: 'Student identification',
    fa_07: 'Doctor communication & release',
    fa_08: 'Photo & media release',
    fa_09: 'Remote learning & teletherapy',
    fa_10: 'School trips & neighborhood walks',
    fa_11: 'Service coordinator information',
    fa_12: 'Social history',
    form_19: 'Handbook acknowledgment',
    fa_14: 'School meal program',
    fa_18: 'PHI authorization',
  },
  woodmere: {
    wm_01: 'K-12 alert letter',
    wm_15: 'Parent handbook',
    wm_16: 'School calendar',
    wm_08: 'Medication authorization (for doctor)',
    wm_03: 'Emergency contacts',
    wm_04: 'Emergency medical authorization',
    wm_05: 'Photo & media release',
    wm_06: 'Teletherapy consent',
    wm_07: 'Medications & supplements',
    wm_09: 'NYC Medicaid consent',
    wm_10: 'Parent transportation',
    wm_11: 'Special alert consent',
    wm_12: 'Special alerts',
    wm_13: 'Nassau Medicaid consent',
    wm_14: 'NYS health form',
    wm_17: 'PHI authorization',
  },
  '55th-street': {
    bs_01: 'Important forms overview',
    bs_02: 'Welcome letter (Forms A–D)',
    bs_03: 'Classroom staff welcome',
    form_02: 'Parent file rights',
    fa_03: 'Bus authorization (Form A)',
    fa_10: 'School trips (Form B)',
    bs_08: 'Photo & video consent (Form C)',
    bs_15: 'Parent handbook',
    form_19: 'Handbook receipt (Form D)',
    bs_06: 'Extra clothing checklist',
    bs_07: 'Nurse cover letter',
    fa_04: 'Emergency procedure',
    form_11: 'Tylenol & Benadryl consent',
    bs_14: 'CH-205 health examination (for doctor)',
    bs_16: 'School calendar',
    bs_17: 'PHI authorization',
  },
};

const SITE_PACKET_LABELS = {
  rockland: 'Rockland packet',
  '14th-ave': '14th Ave packet',
  woodmere: 'Woodmere packet',
  '55th-street': '55th Street packet',
};

export function getPacketPanelTitle(siteName, siteSlug) {
  const trimmed = (siteName || '').trim();
  if (trimmed) {
    return trimmed.toLowerCase().includes('packet') ? trimmed : `${trimmed} packet`;
  }
  return SITE_PACKET_LABELS[siteSlug] || 'Parent packet';
}

export function getFriendlyFormName(siteSlug, formId, fallback = '') {
  const siteMap = PACKET_FRIENDLY_FORM_NAMES[siteSlug] || {};
  return siteMap[formId] || fallback || formId;
}
